import { render, staticRenderFns } from "./password.vue?vue&type=template&id=fc635fa0&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/web/account/settings/_content.scss?vue&type=style&index=0&id=fc635fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc635fa0",
  null
  
)

export default component.exports